import {uniqueId} from 'lodash'

const inputs = [
  {
    label: 'Date',
    type: 'date',
    format: 'DD, MMMM YYYY',
    model: 'dateStart',
    maxDate: new Date(),
    grid: {
      gridTemplateColumns: '167px',
      alignItem: 'center',
      gridGap: '10px'
    }
  },
  {
    label: 'Project',
    type: 'select',
    model: 'project',
    options: [],
    grid: {
      gridTemplateColumns: '1fr',
      alignItem: 'center',
      gridGap: '10px'
    },
    style: {
      textOverflow: 'ellipsis',
      width: '484px'
    },
    listLabel: 'name'
  },
  {
    label: 'Subproject',
    type: 'select',
    model: 'subproject',
    placeholder: 'No entries',
    options: [],
    listLabel: 'name',
    isHide: true
  },
  {
    label: 'Comment',
    type: 'textareaEditor',
    model: 'commentText',
    height: '140px',
    placeholder: 'Enter text...',
    alignItem: 'start',
    grid: {
      gridTemplateColumns: '1fr',
      alignItem: 'center',
      gridGap: '10px'
    },
    inputStyle: {
      whiteSpace: 'pre-wrap'
    },
    options: [],
    isAddUser: true,
    autofocus: true,
    required: true
  },
  {
    title: 'Add to History Tab of Clients',
    type: 'checkbox',
    model: 'clientIsTab'
  },
  {
    title: 'Add to History Tab of Company',
    type: 'selectCompany',
    model: 'companyIsTab',
    required: false
  },
  {
    label: 'Time spent',
    type: 'timerManual',
    model: 'startDateEndDate'
  },
  {
    label: 'User',
    type: 'select',
    options: [],
    listLabel: 'username',
    model: 'user',
    grid: {
      gridTemplateColumns: '1fr',
      alignItem: 'center',
      gridGap: '10px'
    },
    searchable: true,
    searchableBy: 'username',
    clearable: false,
    required: true
  }
]

const prefix = 'input_step_'
const stepsInputs = inputs.map(item => {
  item.id = uniqueId(prefix)
  return item
})

export default stepsInputs



// WEBPACK FOOTER //
// ./src/constants/InputsSettings/stepsInputs.js